/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.feed.threadgate'

export { $nsid }

/** Record defining interaction gating rules for a thread (aka, reply controls). The record key (rkey) of the threadgate record must match the record key of the thread's root post, and that record must be in the same repository. */
type Main = {
  $type: 'app.bsky.feed.threadgate'

  /**
   * Reference (AT-URI) to the post record.
   */
  post: l.AtUriString

  /**
   * List of rules defining who can reply to this post. If value is an empty array, no one can reply. If value is undefined, anyone can reply.
   */
  allow?: (
    | l.$Typed<MentionRule>
    | l.$Typed<FollowerRule>
    | l.$Typed<FollowingRule>
    | l.$Typed<ListRule>
    | l.Unknown$TypedObject
  )[]
  createdAt: l.DatetimeString

  /**
   * List of hidden reply URIs.
   */
  hiddenReplies?: l.AtUriString[]
}

export type { Main }

/** Record defining interaction gating rules for a thread (aka, reply controls). The record key (rkey) of the threadgate record must match the record key of the thread's root post, and that record must be in the same repository. */
const main = l.record<'tid', Main>(
  'tid',
  $nsid,
  l.object({
    post: l.string({ format: 'at-uri' }),
    allow: l.optional(
      l.array(
        l.typedUnion(
          [
            l.typedRef<MentionRule>((() => mentionRule) as any),
            l.typedRef<FollowerRule>((() => followerRule) as any),
            l.typedRef<FollowingRule>((() => followingRule) as any),
            l.typedRef<ListRule>((() => listRule) as any),
          ],
          false,
        ),
        { maxLength: 5 },
      ),
    ),
    createdAt: l.string({ format: 'datetime' }),
    hiddenReplies: l.optional(
      l.array(l.string({ format: 'at-uri' }), { maxLength: 300 }),
    ),
  }),
)

export { main }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main),
  $build = /*#__PURE__*/ main.build.bind(main),
  $type = /*#__PURE__*/ main.$type
export const $assert = /*#__PURE__*/ main.assert.bind(main),
  $check = /*#__PURE__*/ main.check.bind(main),
  $cast = /*#__PURE__*/ main.cast.bind(main),
  $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main),
  $matches = /*#__PURE__*/ main.matches.bind(main),
  $parse = /*#__PURE__*/ main.parse.bind(main),
  $safeParse = /*#__PURE__*/ main.safeParse.bind(main),
  $validate = /*#__PURE__*/ main.validate.bind(main),
  $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)

/** Allow replies from actors mentioned in your post. */
type MentionRule = { $type?: 'app.bsky.feed.threadgate#mentionRule' }

export type { MentionRule }

/** Allow replies from actors mentioned in your post. */
const mentionRule = l.typedObject<MentionRule>(
  $nsid,
  'mentionRule',
  l.object({}),
)

export { mentionRule }

/** Allow replies from actors who follow you. */
type FollowerRule = { $type?: 'app.bsky.feed.threadgate#followerRule' }

export type { FollowerRule }

/** Allow replies from actors who follow you. */
const followerRule = l.typedObject<FollowerRule>(
  $nsid,
  'followerRule',
  l.object({}),
)

export { followerRule }

/** Allow replies from actors you follow. */
type FollowingRule = { $type?: 'app.bsky.feed.threadgate#followingRule' }

export type { FollowingRule }

/** Allow replies from actors you follow. */
const followingRule = l.typedObject<FollowingRule>(
  $nsid,
  'followingRule',
  l.object({}),
)

export { followingRule }

/** Allow replies from actors on a list. */
type ListRule = {
  $type?: 'app.bsky.feed.threadgate#listRule'
  list: l.AtUriString
}

export type { ListRule }

/** Allow replies from actors on a list. */
const listRule = l.typedObject<ListRule>(
  $nsid,
  'listRule',
  l.object({ list: l.string({ format: 'at-uri' }) }),
)

export { listRule }
